import type { KeyboardEvent } from "react";
import { Link } from "react-router-dom";

import type { Section } from "./sections";

/**
 * Second navigation level directly under the topbar. Rendered by the
 * layout from SECTIONS, never by a page. Links, so Tab and Enter work
 * without extra key handling; arrow keys move within the bar.
 */
export function SectionTabs({ section, pathname }: { section: Section; pathname: string }) {
  const onKeyDown = (event: KeyboardEvent<HTMLElement>) => {
    if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") return;
    const links = Array.from(
      event.currentTarget.querySelectorAll<HTMLAnchorElement>("a"),
    );
    const index = links.indexOf(document.activeElement as HTMLAnchorElement);
    if (index < 0) return;
    event.preventDefault();
    const next = event.key === "ArrowRight" ? index + 1 : index - 1;
    links[(next + links.length) % links.length]?.focus();
  };
  return (
    <nav
      className="lt-tabs"
      aria-label={`Bereich ${section.label}`}
      onKeyDown={onKeyDown}
    >
      {section.tabs.map((tab) => {
        const active = pathname === tab.to;
        return (
          <Link
            key={tab.to}
            to={tab.to}
            className="lt-tab"
            aria-current={active ? "page" : undefined}
          >
            {tab.label}
          </Link>
        );
      })}
    </nav>
  );
}
